<template>
  <div>
    <el-card shadow="never" class="page-card">
      <div class="page-header">
        <div class="page-title">摄像头管理</div>
      </div>

      <el-form :inline="true" :model="searchForm" class="search-form">
        <el-form-item label="绑定类型">
          <el-select v-model="searchForm.bindType" placeholder="请选择">
            <el-option label="企业" value="news"></el-option>
            <el-option label="店铺" value="shop"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="设备序列号">
          <el-input v-model="searchForm.deviceId" placeholder="请输入设备序列号" style="width: 200px;"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="search">查询</el-button>
          <el-button @click="reset">重置</el-button>
        </el-form-item>
      </el-form>

      <div style="margin-bottom: 10px;">
        <el-button type="primary" @click="showBindDialog = true">绑定摄像头</el-button>
      </div>

      <el-table v-loading="loadTable" :data="records" size="small" stripe>
        <el-table-column label="ID" prop="id" width="60"/>
        <el-table-column label="设备序列号" prop="deviceId"/>
        <el-table-column label="预览图片" width="100">
          <template slot-scope="{ row }">
            <el-image
                v-if="row.preImg"
                :preview-src-list="[getPreImgUrl(row.preImg)]"
                :src="getPreImgUrl(row.preImg)"
                class="cover-thumb"
                fit="cover"
                style="width: 80px; height: 60px; border-radius: 4px;"
            />
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column label="绑定类型" prop="bindType" width="100">
          <template slot-scope="{ row }">
            <el-tag :type="row.bindType === 'news' ? 'primary' : 'success'">
              {{ row.bindType === 'news' ? '企业' : '店铺' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="绑定对象" width="200">
          <template slot-scope="{ row }">
            <span>{{ row.bindName || '-' }}</span>
            <span style="float: right; color: #8492a6; font-size: 13px">ID: {{ row.bindId }}</span>
          </template>
        </el-table-column>
        <el-table-column label="设备状态" width="140">
          <template slot-scope="{ row }">
            <el-switch
                :value="row.deviceStatus === 'online'"
                active-text="在线"
                inactive-text="离线"
                @change="(val) => toggleDeviceStatus(row.id, val)"
            />
          </template>
        </el-table-column>
        <el-table-column label="创建时间" prop="createdTime"/>
        <el-table-column label="更新时间" prop="updatedTime"/>
        <el-table-column label="操作" width="150">
          <template slot-scope="{ row }">
            <el-button size="mini" type="text" @click="doEditCamera(row)">修改</el-button>
            <el-button size="mini" type="text" @click="doUnbindCamera(row.id)">解绑</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div style="margin-top: 10px; text-align: right;">
        <el-pagination
          @size-change="(val) => { this.size = val; this.fetchData() }"
          @current-change="(val) => { this.current = val; this.fetchData() }"
          :current-page="current"
          :page-sizes="[10, 20, 50]"
          :page-size="size"
          :total="total"
          layout="total, sizes, prev, pager, next, jumper">
        </el-pagination>
      </div>
    </el-card>

    <!-- 绑定摄像头弹窗 -->
    <el-dialog :visible.sync="showBindDialog" class="form-dialog" title="绑定摄像头" width="500px">
      <el-form ref="bindForm" :model="bindForm" label-position="left" label-width="100px" :rules="bindFormRules">
        <el-form-item label="设备序列号" prop="cameraDeviceId">
          <el-input v-model="bindForm.cameraDeviceId" placeholder="请输入设备序列号(S/N)"></el-input>
        </el-form-item>
        <el-form-item label="设备密码" prop="cameraDevCode">
          <el-input v-model="bindForm.cameraDevCode" placeholder="请输入设备密码"></el-input>
        </el-form-item>
        <el-form-item label="设备名称" prop="cameraDeviceName">
          <el-input v-model="bindForm.cameraDeviceName" placeholder="请输入设备名称"></el-input>
        </el-form-item>
        <el-form-item label="是否公开" prop="cameraIsPublic">
          <el-switch v-model="bindForm.cameraIsPublic" active-text="公开" inactive-text="私有"></el-switch>
        </el-form-item>
        <el-form-item label="观看密码" prop="cameraViewPassword" v-if="!bindForm.cameraIsPublic">
          <el-input v-model="bindForm.cameraViewPassword" placeholder="设为私有时有必填" :disabled="bindForm.cameraIsPublic"></el-input>
        </el-form-item>
        <el-form-item label="绑定类型" prop="cameraBindType">
          <el-select v-model="bindForm.cameraBindType" placeholder="请选择" @change="handleBindTypeChange('bind')">
            <el-option label="企业" value="news"></el-option>
            <el-option label="店铺" value="shop"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="绑定对象" prop="cameraBindId">
          <el-select v-model="bindForm.cameraBindId" placeholder="请选择" filterable>
            <el-option
                v-for="item in (bindForm.cameraBindType === 'news' ? newsList : shopList)"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              <span style="float: left">{{ item.label }}</span>
              <span style="float: right; color: #8492a6; font-size: 13px">{{ item.value }}</span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="预览图片" prop="cameraPreImg">
          <div class="avatar-uploader">
            <el-upload
                :action="fileBaseUrl"
                :show-file-list="false"
                :data="uploadData"
                accept="image/*"
                :before-upload="beforeUpload"
                :on-success="(response, file) => handleBindSuccess(response, file)"
            >
              <img v-if="bindForm.cameraPreImg" :src="bindForm.cameraPreImg" class="avatar">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showBindDialog = false">取 消</el-button>
        <el-button type="primary" @click="doBindCamera">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 修改摄像头弹窗 -->
    <el-dialog :visible.sync="showEditDialog" class="form-dialog" title="修改摄像头" width="500px">
      <el-form ref="editForm" :model="editForm" label-position="left" label-width="100px" :rules="editFormRules">
        <el-form-item label="设备名称" prop="cameraDeviceName">
          <el-input v-model="editForm.cameraDeviceName" placeholder="请输入设备名称"></el-input>
        </el-form-item>
        <el-form-item label="是否公开" prop="cameraIsPublic">
          <el-switch v-model="editForm.cameraIsPublic" active-text="公开" inactive-text="私有"></el-switch>
        </el-form-item>
        <el-form-item label="观看密码" prop="cameraViewPassword" v-if="!editForm.cameraIsPublic">
          <el-input v-model="editForm.cameraViewPassword" placeholder="设为私有时有必填" :disabled="editForm.cameraIsPublic"></el-input>
        </el-form-item>
        <el-form-item label="绑定类型" prop="cameraBindType">
          <el-select v-model="editForm.cameraBindType" placeholder="请选择" @change="handleBindTypeChange('edit')">
            <el-option label="企业" value="news"></el-option>
            <el-option label="店铺" value="shop"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="绑定对象" prop="cameraBindId">
          <el-select v-model="editForm.cameraBindId" placeholder="请选择" filterable>
            <el-option
                v-for="item in (editForm.cameraBindType === 'news' ? newsList : shopList)"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              <span style="float: left">{{ item.label }}</span>
              <span style="float: right; color: #8492a6; font-size: 13px">{{ item.value }}</span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="预览图片" prop="cameraPreImg">
          <div class="avatar-uploader">
            <el-upload
                :action="fileBaseUrl"
                :show-file-list="false"
                :data="uploadData"
                accept="image/*"
                :before-upload="beforeUpload"
                :on-success="(response, file) => handleEditSuccess(response, file)"
            >
              <img v-if="editForm.cameraPreImg" :src="editForm.cameraPreImg" class="avatar">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showEditDialog = false">取 消</el-button>
        <el-button type="primary" @click="doEditCameraSubmit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {Message} from "element-ui";
import bindCamera from "@/api/camera/bindCamera";
import cameraPage from "@/api/camera/page";
import unbindCamera from "@/api/camera/unbind";
import updateCamera from "@/api/camera/updateCamera";
import updateDeviceStatus from "@/api/camera/updateDeviceStatus";
import adminGetNews from "@/api/user/admin-controler/adminGetNews";
import pageShop from "@/api/store/StoreShop/page";
import getAliyunOssSign from "@/api/common/getAliyunOssSign";
import adminGetFileSignUrl from "@/api/common/adminGetFileSignUrl";

export default {
  name: "CameraManage",
  data() {
    return {
      current: 1,
      size: 10,
      total: 0,
      loadTable: false,
      records: [],
      searchForm: {
        bindType: '',
        deviceId: ''
      },
      showBindDialog: false,
      showEditDialog: false,
      bindForm: {
        cameraDeviceId: '',
        cameraDevCode: '',
        cameraDeviceName: '',
        cameraIsPublic: true,
        cameraViewPassword: '',
        cameraBindType: 'news',
        cameraBindId: '',
        cameraPreImg: ''
      },
      editForm: {
        id: '',
        cameraDeviceName: '',
        cameraIsPublic: true,
        cameraViewPassword: '',
        cameraBindType: 'news',
        cameraBindId: '',
        cameraPreImg: ''
      },
      newsList: [],
      shopList: [],
      fileBaseUrl: process.env.VUE_APP_FILE_BASE_URL,
      uploadData: {}
    }
  },
  computed: {
    bindFormRules() {
      return {
        cameraDeviceId: [
          { required: true, message: '请输入设备序列号', trigger: 'blur' }
        ],
        cameraDevCode: [
          { required: true, message: '请输入设备密码', trigger: 'blur' }
        ],
        cameraDeviceName: [
          { required: true, message: '请输入设备名称', trigger: 'blur' }
        ],
        cameraViewPassword: [
          { required: () => !this.bindForm.cameraIsPublic, message: '请输入观看密码', trigger: 'blur' }
        ],
        cameraBindType: [
          { required: true, message: '请选择绑定类型', trigger: 'change' }
        ],
        cameraBindId: [
          { required: true, message: '请选择绑定对象', trigger: 'change' }
        ],
        cameraPreImg: [
          { required: true, message: '请上传预览图片', trigger: 'change' }
        ]
      }
    },
    editFormRules() {
      return {
        cameraDeviceName: [
          { required: true, message: '请输入设备名称', trigger: 'blur' }
        ],
        cameraViewPassword: [
          { required: () => !this.editForm.cameraIsPublic, message: '请输入观看密码', trigger: 'blur' }
        ],
        cameraBindType: [
          { required: true, message: '请选择绑定类型', trigger: 'change' }
        ],
        cameraBindId: [
          { required: true, message: '请选择绑定对象', trigger: 'change' }
        ],
        cameraPreImg: [
          { required: true, message: '请上传预览图片', trigger: 'change' }
        ]
      }
    }
  },
  mounted() {
    this.fetchData()
    this.loadBindOptions()
  },
  methods: {
    fetchData() {
      this.loadTable = true
      let params = {}
      if (this.searchForm.bindType) {
        params.bindType = this.searchForm.bindType
      }
      if (this.searchForm.deviceId) {
        params.deviceId = this.searchForm.deviceId
      }
      cameraPage(this.current, this.size, params).then(res => {
        this.records = res.data.data || []
        this.total = res.data.total || 0
      }).finally(() => {
        this.loadTable = false
      })
    },
    search() {
      this.current = 1
      this.fetchData()
    },
    reset() {
      this.searchForm = {
        bindType: '',
        deviceId: ''
      }
      this.search()
    },
    async loadBindOptions() {
      let current = 1
      let allNews = []
      let allShops = []

      while (true) {
        const newsRes = await adminGetNews(current, 100, {})
        const newsData = newsRes.data.data || []
        allNews = allNews.concat(newsData)
        if (newsData.length < 100) break
        current++
      }
      this.newsList = allNews.map(e => ({value: '' + e.id, label: e.title}))

      current = 1
      while (true) {
        const shopRes = await pageShop(current, 100, {})
        const shopData = shopRes.data.data || []
        allShops = allShops.concat(shopData)
        if (shopData.length < 100) break
        current++
      }
      this.shopList = allShops.map(e => ({value: '' + e.id, label: e.name}))
    },
    handleBindTypeChange(formType) {
      if (formType === 'bind') {
        this.bindForm.cameraBindId = ''
      } else {
        this.editForm.cameraBindId = ''
      }
    },
    getPreImgUrl(preImg) {
      if (!preImg) return ''
      return this.fileBaseUrl + '/' + preImg
    },
    async beforeUpload() {
      await getAliyunOssSign("/common/sign").then(response => {
        let resultObj = response.data
        this.uploadData = resultObj
        this.uploadData.ossaccessKeyId = resultObj.accessid
        this.uploadData.key = resultObj.dir + '/' + this.getUUID() + '_${filename}'
      })
      return true
    },
    getUUID() {
      var s = []
      var hexDigits = "0123456789abcdef"
      for (var i = 0; i < 36; i++) {
        s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1)
      }
      s[14] = "4"
      s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1)
      s[8] = s[13] = s[18] = s[23] = "-"
      return s.join("")
    },
    handleBindSuccess(response, file) {
      var urlPath = this.uploadData.host + '/' + this.uploadData.key.replace("${filename}", file.name)
      let filepath = urlPath.substring(this.fileBaseUrl.length + 1)
      adminGetFileSignUrl(filepath).then(res => {
        this.bindForm.cameraPreImg = res.data
      })
    },
    handleEditSuccess(response, file) {
      var urlPath = this.uploadData.host + '/' + this.uploadData.key.replace("${filename}", file.name)
      let filepath = urlPath.substring(this.fileBaseUrl.length + 1)
      adminGetFileSignUrl(filepath).then(res => {
        this.editForm.cameraPreImg = res.data
      })
    },
    doBindCamera() {
      this.$refs.bindForm.validate((valid) => {
        if (!valid) return
        let preImg = ''
        if (this.bindForm.cameraPreImg) {
          preImg = this.bindForm.cameraPreImg.split('?')[0].substring(this.fileBaseUrl.length + 1)
        }
        bindCamera({
          deviceId: this.bindForm.cameraDeviceId,
          devCode: this.bindForm.cameraDevCode,
          deviceName: this.bindForm.cameraDeviceName,
          isPublic: this.bindForm.cameraIsPublic,
          viewPassword: this.bindForm.cameraViewPassword,
          bindType: this.bindForm.cameraBindType,
          bindId: this.bindForm.cameraBindId,
          preImg: preImg
        }).then(res => {
          if (res.code === 1) {
            Message({message: '绑定成功', type: 'success', duration: 3000})
            this.showBindDialog = false
            this.resetBindForm()
            this.fetchData()
          } else {
            let errorMsg = res.msg
            if (res.data && res.data.illError) {
              errorMsg = res.data.illError
            }
            Message({message: errorMsg, type: 'error', duration: 3000})
          }
        })
      })
    },
    doEditCamera(row) {
      this.editForm = {
        id: row.id,
        cameraDeviceName: row.deviceName || '',
        cameraIsPublic: row.isPublic === undefined ? true : row.isPublic,
        cameraViewPassword: row.viewPassword || '',
        cameraBindType: row.bindType,
        cameraBindId: '' + row.bindId,
        cameraPreImg: this.getPreImgUrl(row.preImg)
      }
      this.showEditDialog = true
    },
    doEditCameraSubmit() {
      this.$refs.editForm.validate((valid) => {
        if (!valid) return
        let preImg = ''
        if (this.editForm.cameraPreImg) {
          preImg = this.editForm.cameraPreImg.split('?')[0].substring(this.fileBaseUrl.length + 1)
        }
        updateCamera({
          id: this.editForm.id,
          deviceName: this.editForm.cameraDeviceName,
          isPublic: this.editForm.cameraIsPublic,
          viewPassword: this.editForm.cameraViewPassword,
          bindType: this.editForm.cameraBindType,
          bindId: this.editForm.cameraBindId,
          preImg: preImg
        }).then(res => {
          if (res.code === 1) {
            Message({message: '修改成功', type: 'success', duration: 3000})
            this.showEditDialog = false
            this.resetEditForm()
            this.fetchData()
          } else {
            Message({message: res.message, type: 'error', duration: 3000})
          }
        })
      })
    },
    resetBindForm() {
      this.bindForm = {
        cameraDeviceId: '',
        cameraDevCode: '',
        cameraDeviceName: '',
        cameraIsPublic: true,
        cameraViewPassword: '',
        cameraBindType: 'news',
        cameraBindId: '',
        cameraPreImg: ''
      }
    },
    resetEditForm() {
      this.editForm = {
        id: '',
        cameraDeviceName: '',
        cameraIsPublic: true,
        cameraViewPassword: '',
        cameraBindType: 'news',
        cameraBindId: '',
        cameraPreImg: ''
      }
    },
    toggleDeviceStatus(id, value) {
      updateDeviceStatus({
        id: id,
        deviceStatus: value ? 'online' : 'offline'
      }).then(res => {
        if (res.code === 1) {
          Message({message: '设备状态更新成功', type: 'success', duration: 3000})
          this.fetchData()
        } else {
          Message({message: res.msg, type: 'error', duration: 3000})
          this.fetchData()
        }
      })
    },
    doUnbindCamera(id) {
      this.$confirm('确认解绑此摄像头？', '操作确认', {type: 'warning'}).then(() => {
        unbindCamera(id).then(res => {
          if (res.code === 1) {
            Message({message: '解绑成功', type: 'success', duration: 3000})
            this.fetchData()
          } else {
            Message({message: res.message, type: 'error', duration: 3000})
          }
        })
      })
    }
  }
}
</script>

<style scoped>
.page-card {
  margin: 10px;
}
.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}
.page-title {
  font-size: 18px;
  font-weight: bold;
  color: #303133;
}
.avatar-uploader {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 100px;
  height: 100px;
  .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 100px;
    height: 100px;
    line-height: 100px;
    text-align: center;
  }
  .avatar {
    width: 100px;
    height: 100px;
    display: block;
  }
}
.search-form {
  margin-bottom: 15px;
}
</style>
